var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box"},[_c('van-search',{staticClass:"sticky",attrs:{"shape":"round","placeholder":_vm.placeholder},on:{"search":_vm.onSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }